import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceService } from '@flyfreely-portal-ui/flyfreely';
import { setupStatusFormatter } from '../helpers';

@Pipe({ name: 'formatMaintenanceEquipmentCategory' })
export class FormatMaintenanceEquipmentCategoryPipe implements PipeTransform {
    transform: (value: any, ...args: any[]) => any;

    constructor(maintenanceService: MaintenanceService) {
        this.transform = setupStatusFormatter(
            maintenanceService.getEquipmentTypes()
        );
    }
}
